const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  roles: state => state.user.roles,
  userId: state => state.user.userId,
  email: state => state.user.email,
  shelfId: state => state.user.shelfId,
  managerFlag: state => state.user.managerFlag,
  shelfName: state => state.user.shelfName,
  roleTypeList: state => state.user.roleTypeList,
  addRouters: state => state.permission.addRouters,
  routers: state => state.permission.routers,
  imUser: state => state.im.imUser,
  systemUnreadCount: state => state.im.systemUnreadCount,
  pageCacheVersion: state => state.pageCache.version,
  breadcrumbParent: state => state.pageCache.breadcrumbParent
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js